import './index.css';
import React from 'react';

const Header = () => {
    React.useEffect(() => {
        console.log('Header Mounted');
    }, []);

    return (
        <header className='App-header'>
            <h1 className='title'>Alan Tsui</h1>
            <p className='normal'>
                computer science major at{' '}
                <a href='https://ucsd.edu/'>
                    <span className='name'>UC San Diego</span>
                </a>
            </p>
            <div className='flex-container'>
                <div className='row'>
                    <div className='col-6'>
                        <a
                            type='button'
                            href='https://drive.google.com/file/d/1B5aTRzMcSB5R9uPIek5PFfRB-PnSVhM0/view?usp=sharing'
                            className='btn btn-primary button'>
                            Resume
                        </a>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
